var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDifferenceIdentity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 20L14 40H18V20H14Z",
    fill: "#FFFF81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 42V18H26V42H22Z",
    fill: "#FFFF81"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44V16H44V44H30Z",
    fill: "#FFFF81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifferenceIdentity);
export default __webpack_public_path__ + "static/media/difference_identity.5805b37f4096c1f3a5c0e2e5fe6c8e33.svg";
export { ForwardRef as ReactComponent };